module.exports = __webpack_public_path__ + "img/020.3a5cf06d.png";